import { Injectable } from "@angular/core";
import { EventTypesByProductIdsDto } from "@dto/email-products/event-types-by-product-ids.dto";
import { NotificationListFiltersTeamsChatDto } from "@dto/notification-list/notification-list-filters-teams-chat.dto";
import { NotificationListFiltersTeamsChannelDto } from "@dto/notification-list/notification-list-filters-teams-channel.dto";
import { NotificationListFiltersTeamsCampaignDto } from "@dto/notification-list/notification-list-filters-teams-campaign.dto";
import { NotificationListFiltersEmailSmsDto } from "@dto/notification-list/notification-list-filters-email-sms.dto";
import { NotificationDetailDto } from "@dto/notification-detail/notification-detail.dto";
import { NotificationListDto } from "@dto/notification-list/notification-list.dto";
import { environment } from "@environments/environment";
import { AuthHttpClientService } from "@service/auth-http-client.service";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: 'any',
})
export class NotificationService {
  private readonly notificationUrl: string = `${environment.tmnBackApi}/notification`;
  private readonly teamsUrl: string = `${environment.tmnBackApi}/teams/notifications`;

  constructor(private readonly http: AuthHttpClientService) {
  }

  searchTeamsChats(currentPageNumber: number, filters: NotificationListFiltersTeamsChatDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.teamsUrl}/chats?page=${currentPageNumber}&size=${pageSize}`, stripEmptyValues(filters));
  }

  searchTeamsChannels(currentPageNumber: number, filters: NotificationListFiltersTeamsChannelDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.teamsUrl}/channels?page=${currentPageNumber}&size=${pageSize}`, stripEmptyValues(filters));
  }

  searchTeamsCampaigns(currentPageNumber: number, filters: NotificationListFiltersTeamsCampaignDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.teamsUrl}/campaigns?page=${currentPageNumber}&size=${pageSize}`, stripEmptyValues(filters));
  }

  getNotificationListEmailSms(currentPageNumber: number, filters: NotificationListFiltersEmailSmsDto, pageSize: number): Observable<NotificationListDto> {
    return this.http.post<NotificationListDto>(`${this.notificationUrl}/list?page=${currentPageNumber}&size=${pageSize}`, filters);
  }

  getNotificationDetail(sourceId: string): Observable<NotificationDetailDto> {
    return this.http.post<NotificationDetailDto>(`${this.notificationUrl}/detail/${sourceId}`);
  }

  getPublicEmailProductIds(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${environment.tmnBackApi}/products/emails/public`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }

  getEmailEventTypesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${environment.tmnBackApi}/products/emails`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }

  getSmsEventTypesByProductId(): Observable<{ [productId: string]: string[] }> {
    return this.http.get<EventTypesByProductIdsDto>(`${environment.tmnBackApi}/products/sms`).pipe(
      map(response => response.eventTypesByProductId)
    );
  }
}

function stripEmptyValues<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null && v !== '' && !(Array.isArray(v) && v.length === 0))
  ) as Partial<T>;
}



